<template lang="pug">
  article.relative.pt-72.pb-90.md-py-0(v-if="product")
    section.md-flex.justify-between.items-center
        //- carousel
        figure.relative.bg-gray-100-off.pb-130pct.md-pb-0.md-fixed.top-0.right-0.md-h-screen.md-w-1x2.select-none(@click="next(1)", @mouseenter="pause", @mouseleave="play", :style="{cursor: product.images.length > 1 && 'e-resize'}")
          //- images
          product-image(v-for="(img, i) in product.images", :image="img", :class="{'invisible': active !== i}", :key="i")
          //- count
          .absolute.bottom-0.right-0.p-16.text-14 {{ active + 1 }}&mdash;{{ product.images.length}}

        //- text
        aside.p-12.md-w-1x2.md-px-40.md-py-90.lg-px-72.md-min-h-screen.md-flex.md-items-end
          .md-max-w-lg
            .p-12.md-border-none.md-m-0.md-p-0.md-relative
              .uppercase.leading-snug
                header
                  //- title
                  h1.text-22.md-text-24.md-w-3x4.leading-tight {{ product.title }}
                  //- price
                  h6.text-22.md-text-24.md-mt-24
                    //- current
                    //- span(:class="{'text-red': price(activeVariant).reduced}")
                    | {{ price(activeVariant).price }}
                    //- compare at
                    span.line-through.inline-block.ml-12.text-gray-400(v-if="price(activeVariant).reduced")
                      | {{ price(activeVariant).compareAt }}
                  h6.text-9.mt-4 Incl. VAT / Excl. Shipping
                .text-14.mt-24.children-mt-em(v-html="product.descriptionHtml")
                //- options
                nav.text-13.mt-12(v-if="product.variants.length > 1")
                  button.inline-block.p-4.mr-12.border.border-transp.rounded(v-for="variant in product.variants", :class="{'border-black border-dotted': selected === variant.id, 'text-gray-400': !variant.available}", @click="selected = variant.id") {{variant.title}}
                //- select.mt-24.text-14.border.rounded.uppercase(v-model="selected", style="font-family:system-ui")
                  option(v-for="variant in product.variants", v-bind:value="variant.id") {{variant.title}}
                div.mt-32.md-mt-48.text-22.md-text-24
                  button(v-if="price(activeVariant).avail", @click="addToCart(activeVariant.id)")
                    span(v-if="isPreOrder") PRE-ORDER ☞
                    span(v-else) ADD TO CART ☞
                  span(v-else) {{ price(activeVariant).msg }}

    //- footer.pt-12.border-t
      home

</template>

<script>
import ProductImage from '@/components/Product__Image'
import { mapGetters, mapActions } from 'vuex'
import { getDefaultVariant, getFilename } from '@/utils'
export default {
  name: 'Product',
  props: ['handle'],
  data () {
    return {
      product: null,
      active: 0,
      intvl: null,
      selected: null
    }
  },
  computed: {
    ...mapGetters(['price']),
    activeVariant () {
      return this.product && this.product.variants.find(v => v.id === this.selected)
    },
    isPreOrder () {
      return this.product && this.product.productType && this.product.productType.toLowerCase() === 'pre-order'
    }
  },
  methods: {
    ...mapActions(['addToCart']),
    next (dir = 1) {
      const actv = this.active
      const total = this.product.images.length
      this.active = actv + dir > total - 1 ? 0 : actv + dir < 0 ? total - 1 : actv + dir
      this.play()
    },
    play () {
      clearTimeout(this.intvl)
      this.intvl = setTimeout(() => {
        this.next()
        this.play()
      }, 3000)
    },
    pause () {
      clearTimeout(this.intvl)
    },
    setActive (imgs) {
      const found = imgs.findIndex(img => img.src && getFilename(img.src).includes('FIRST'))
      this.active = found > -1 ? found : imgs.length > 1 ? 1 : 0
    }
  },
  created () {
    this.$store.dispatch('getProduct', this.handle).then(p => {
      this.product = p
      const v = getDefaultVariant(p)
      this.selected = v && v.id
      this.setActive(p.images)
      this.play()
    })
  },
  metaInfo () {
    if (this.product) {
      const img = this.product.images[0]
      const meta = this.$store.getters.meta({
        title: this.product.title,
        descrip: this.product.description,
        img: img && img.src
      })
      // no index ?
      // meta.push({name: 'robots', content: 'noindex' })
      return {
        title: this.product.title,
        meta: meta,
        link: [
          { rel: 'canonical', href: process.env.VUE_APP_DOMAIN + '/products/' + this.product.handle }
        ]
      }
    }
  },
  components: { ProductImage }
}
</script>

<style>
</style>
